
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  expiresAt: 'expiresAt'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  ownerId: 'ownerId',
  role: 'role',
  external: 'external'
};

exports.Prisma.AppScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  summary: 'summary',
  description: 'description',
  instructions: 'instructions',
  license: 'license',
  repository: 'repository',
  tags: 'tags',
  autoUpdate: 'autoUpdate',
  scope: 'scope',
  writeData: 'writeData'
};

exports.Prisma.AppIconScalarFieldEnum = {
  appId: 'appId',
  mime: 'mime'
};

exports.Prisma.AppMediaScalarFieldEnum = {
  id: 'id',
  appId: 'appId',
  mime: 'mime',
  hero: 'hero'
};

exports.Prisma.AppPermissionScalarFieldEnum = {
  userId: 'userId',
  appId: 'appId',
  editApp: 'editApp',
  uploadApp: 'uploadApp',
  manageApp: 'manageApp',
  readData: 'readData',
  writeData: 'writeData',
  manageData: 'manageData'
};

exports.Prisma.AppVersionScalarFieldEnum = {
  id: 'id',
  appId: 'appId',
  name: 'name',
  scope: 'scope'
};

exports.Prisma.AppVersionPermissionScalarFieldEnum = {
  userId: 'userId',
  versionId: 'versionId'
};

exports.Prisma.AppBuildScalarFieldEnum = {
  id: 'id',
  size: 'size',
  offset: 'offset',
  storageType: 'storageType',
  storagePath: 'storagePath',
  storageBucket: 'storageBucket',
  created: 'created',
  mime: 'mime',
  executable: 'executable',
  filename: 'filename',
  appVersionId: 'appVersionId',
  platform: 'platform'
};

exports.Prisma.AppDeviceTargetScalarFieldEnum = {
  buildId: 'buildId',
  deviceId: 'deviceId'
};

exports.Prisma.AppLocationScalarFieldEnum = {
  appId: 'appId',
  locationId: 'locationId'
};

exports.Prisma.DeviceTypeScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  canon: 'canon',
  name: 'name',
  summary: 'summary',
  description: 'description'
};

exports.Prisma.DeviceIconScalarFieldEnum = {
  typeId: 'typeId',
  mime: 'mime'
};

exports.Prisma.DeviceScalarFieldEnum = {
  id: 'id',
  name: 'name',
  key: 'key',
  validUntil: 'validUntil',
  status: 'status',
  messagingToken: 'messagingToken',
  platform: 'platform',
  typeId: 'typeId',
  tags: 'tags',
  available: 'available',
  configGroupId: 'configGroupId',
  locationId: 'locationId'
};

exports.Prisma.DeviceInstructionScalarFieldEnum = {
  key: 'key',
  deviceId: 'deviceId',
  timestamp: 'timestamp',
  type: 'type',
  payload: 'payload'
};

exports.Prisma.DeviceGroupAssignmentScalarFieldEnum = {
  groupId: 'groupId',
  deviceId: 'deviceId'
};

exports.Prisma.DeviceGroupScalarFieldEnum = {
  id: 'id',
  name: 'name',
  config: 'config',
  locationId: 'locationId'
};

exports.Prisma.DeviceGroupAppScalarFieldEnum = {
  groupId: 'groupId',
  appId: 'appId',
  versionId: 'versionId'
};

exports.Prisma.DeviceGroupExternalAppScalarFieldEnum = {
  id: 'id',
  groupId: 'groupId',
  type: 'type',
  name: 'name',
  url: 'url'
};

exports.Prisma.DeviceReservationScalarFieldEnum = {
  deviceId: 'deviceId',
  reservationId: 'reservationId',
  status: 'status',
  notes: 'notes'
};

exports.Prisma.ReservationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  start: 'start',
  end: 'end',
  locationId: 'locationId',
  groupId: 'groupId'
};

exports.Prisma.WebAppScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  url: 'url',
  summary: 'summary',
  description: 'description',
  instructions: 'instructions',
  tags: 'tags',
  writeData: 'writeData'
};

exports.Prisma.WebAppIconScalarFieldEnum = {
  webAppId: 'webAppId',
  mime: 'mime'
};

exports.Prisma.WebAppMediaScalarFieldEnum = {
  id: 'id',
  webAppId: 'webAppId',
  mime: 'mime',
  hero: 'hero'
};

exports.Prisma.WebAppPermissionScalarFieldEnum = {
  userId: 'userId',
  webAppId: 'webAppId',
  editApp: 'editApp',
  manageApp: 'manageApp',
  readData: 'readData',
  writeData: 'writeData',
  manageData: 'manageData'
};

exports.Prisma.LocationScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  summary: 'summary',
  description: 'description'
};

exports.Prisma.LocationIconScalarFieldEnum = {
  locationId: 'locationId',
  mime: 'mime'
};

exports.Prisma.LocationHeroScalarFieldEnum = {
  locationId: 'locationId',
  mime: 'mime'
};

exports.Prisma.ResourceScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  url: 'url',
  summary: 'summary',
  description: 'description',
  tags: 'tags'
};

exports.Prisma.ResourceIconScalarFieldEnum = {
  resourceId: 'resourceId',
  mime: 'mime'
};

exports.Prisma.ResourceMediaScalarFieldEnum = {
  id: 'id',
  resourceId: 'resourceId',
  mime: 'mime',
  hero: 'hero'
};

exports.Prisma.PublicationScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  url: 'url',
  summary: 'summary',
  description: 'description',
  tags: 'tags'
};

exports.Prisma.PublicationIconScalarFieldEnum = {
  publicationId: 'publicationId',
  mime: 'mime'
};

exports.Prisma.PublicationMediaScalarFieldEnum = {
  id: 'id',
  publicationId: 'publicationId',
  mime: 'mime',
  hero: 'hero'
};

exports.Prisma.ProfileScalarFieldEnum = {
  userId: 'userId',
  role: 'role',
  bio: 'bio'
};

exports.Prisma.UserAvatarScalarFieldEnum = {
  profileId: 'profileId',
  mime: 'mime'
};

exports.Prisma.UserLocationScalarFieldEnum = {
  locationId: 'locationId',
  userId: 'userId',
  operator: 'operator',
  visible: 'visible'
};

exports.Prisma.SettingsScalarFieldEnum = {
  key: 'key',
  value: 'value'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.Role = exports.$Enums.Role = {
  ADMIN: 'ADMIN',
  MODERATOR: 'MODERATOR',
  OPERATOR: 'OPERATOR',
  EDITOR: 'EDITOR',
  USER: 'USER'
};

exports.Scope = exports.$Enums.Scope = {
  PUBLIC: 'PUBLIC',
  EDUCATION: 'EDUCATION',
  INTERNAL: 'INTERNAL',
  PRIVATE: 'PRIVATE'
};

exports.Platform = exports.$Enums.Platform = {
  WINDOWS: 'WINDOWS',
  MACOS: 'MACOS',
  LINUX: 'LINUX',
  ANDROID: 'ANDROID',
  IOS: 'IOS'
};

exports.DeviceCanon = exports.$Enums.DeviceCanon = {
  APPLE_VISION_PRO: 'APPLE_VISION_PRO',
  HP_WMR: 'HP_WMR',
  HP_REVERB: 'HP_REVERB',
  HP_REVERB_G2: 'HP_REVERB_G2',
  HTC_VIVE: 'HTC_VIVE',
  HTC_VIVE_COSMOS: 'HTC_VIVE_COSMOS',
  HTC_VIVE_FLOW: 'HTC_VIVE_FLOW',
  HTC_VIVE_FOCUS: 'HTC_VIVE_FOCUS',
  HTC_VIVE_FOCUS_3: 'HTC_VIVE_FOCUS_3',
  HTC_VIVE_FOCUS_VISION: 'HTC_VIVE_FOCUS_VISION',
  HTC_VIVE_PRO: 'HTC_VIVE_PRO',
  HTC_VIVE_PRO_2: 'HTC_VIVE_PRO_2',
  HTC_VIVE_PRO_EYE: 'HTC_VIVE_PRO_EYE',
  HTC_VIVE_XR_ELITE: 'HTC_VIVE_XR_ELITE',
  META_QUEST_2: 'META_QUEST_2',
  META_QUEST_3: 'META_QUEST_3',
  META_QUEST_PRO: 'META_QUEST_PRO',
  MICROSOFT_HOLOLENS: 'MICROSOFT_HOLOLENS',
  OCULUS_GO: 'OCULUS_GO',
  OCULUS_QUEST: 'OCULUS_QUEST',
  OCULUS_RIFT_CV1: 'OCULUS_RIFT_CV1',
  OCULUS_RIFT_S: 'OCULUS_RIFT_S',
  PICO_1: 'PICO_1',
  PICO_G2: 'PICO_G2',
  PICO_NEO_2: 'PICO_NEO_2',
  PICO_NEO_3: 'PICO_NEO_3',
  PICO_4: 'PICO_4',
  PICO_4E: 'PICO_4E',
  PICO_NEO_CV: 'PICO_NEO_CV',
  PICO_GOBLIN: 'PICO_GOBLIN',
  PIMAX_4K: 'PIMAX_4K',
  PIMAX_5K: 'PIMAX_5K',
  PIMAX_8K: 'PIMAX_8K',
  PLAYSTATION_VR: 'PLAYSTATION_VR',
  PLAYSTATION_VR2: 'PLAYSTATION_VR2',
  VALVE_INDEX: 'VALVE_INDEX',
  VARJO_VR1: 'VARJO_VR1',
  VARJO_VR2: 'VARJO_VR2',
  VARJO_VR3: 'VARJO_VR3',
  VARJO_XR4: 'VARJO_XR4',
  OTHER: 'OTHER'
};

exports.DeviceInstructionType = exports.$Enums.DeviceInstructionType = {
  START_APP: 'START_APP',
  STOP_APP: 'STOP_APP',
  CASTING: 'CASTING',
  PUSH_FILE: 'PUSH_FILE',
  PULL_FILE: 'PULL_FILE'
};

exports.DeviceGroupExternalAppType = exports.$Enums.DeviceGroupExternalAppType = {
  FILE: 'FILE',
  XRSCALEKIT: 'XRSCALEKIT',
  PREINSTALLED: 'PREINSTALLED'
};

exports.DeviceReservationStatus = exports.$Enums.DeviceReservationStatus = {
  REQUESTED: 'REQUESTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  ACTIVE: 'ACTIVE',
  RETURNED: 'RETURNED',
  OVERDUE: 'OVERDUE',
  UNKNOWN: 'UNKNOWN'
};

exports.Prisma.ModelName = {
  Session: 'Session',
  User: 'User',
  App: 'App',
  AppIcon: 'AppIcon',
  AppMedia: 'AppMedia',
  AppPermission: 'AppPermission',
  AppVersion: 'AppVersion',
  AppVersionPermission: 'AppVersionPermission',
  AppBuild: 'AppBuild',
  AppDeviceTarget: 'AppDeviceTarget',
  AppLocation: 'AppLocation',
  DeviceType: 'DeviceType',
  DeviceIcon: 'DeviceIcon',
  Device: 'Device',
  DeviceInstruction: 'DeviceInstruction',
  DeviceGroupAssignment: 'DeviceGroupAssignment',
  DeviceGroup: 'DeviceGroup',
  DeviceGroupApp: 'DeviceGroupApp',
  DeviceGroupExternalApp: 'DeviceGroupExternalApp',
  DeviceReservation: 'DeviceReservation',
  Reservation: 'Reservation',
  WebApp: 'WebApp',
  WebAppIcon: 'WebAppIcon',
  WebAppMedia: 'WebAppMedia',
  WebAppPermission: 'WebAppPermission',
  Location: 'Location',
  LocationIcon: 'LocationIcon',
  LocationHero: 'LocationHero',
  Resource: 'Resource',
  ResourceIcon: 'ResourceIcon',
  ResourceMedia: 'ResourceMedia',
  Publication: 'Publication',
  PublicationIcon: 'PublicationIcon',
  PublicationMedia: 'PublicationMedia',
  Profile: 'Profile',
  UserAvatar: 'UserAvatar',
  UserLocation: 'UserLocation',
  Settings: 'Settings'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
